// src/AudioSpectrum/effects/roundedBars.js
import { getColor } from '../colorUtils.js';

export const drawRoundedBars = (ctx, frequencyData, width, height) => {
  const barCount = Math.min(frequencyData.length / 2, 128);
  const barWidth = width / barCount;
  const radius = Math.min(barWidth / 4, 5);
  
  ctx.clearRect(0, 0, width, height);
  
  for (let i = 0; i < barCount; i++) {
    const value = frequencyData[i];
    const barHeight = (value / 255) * height;
    const x = i * barWidth;
    const y = height - barHeight;
    const w = barWidth - 2;
    const h = barHeight;
    
    ctx.fillStyle = getColor(value);
    
    // 둥근 모서리 사각형 그리기
    ctx.beginPath();
    ctx.moveTo(x + radius, y);
    ctx.lineTo(x + w - radius, y);
    ctx.quadraticCurveTo(x + w, y, x + w, y + radius);
    ctx.lineTo(x + w, y + h);
    ctx.lineTo(x, y + h);
    ctx.lineTo(x, y + radius);
    ctx.quadraticCurveTo(x, y, x + radius, y);
    ctx.fill();
  }
};